import application_settings from '../applicationSettings';
import Event from './Event';

class SetDefaultAddress extends Event {
  eventName = "oms_setDefaultAddress";

  constructor() {
    super();
    this.add();
  }

  /**
   * @override
   *
   * Event Function for Get loyalty points
   *
   * @return void
   *
   */
  eventFunction(data) {
    let thisObj = this;
    let requestId = data.request_id ? data.request_id : "";
    let action = data.action ? data.action : "";
    let address_id = data.address_id ? data.address_id : "";
    let type = data.type ? data.type : "";

    // request data
    data.endPoint = application_settings.endPoints.setDefaultAddress;
    data.method = 'POST';
    data.canUsePublicAuth = false;
    data.data = {
      address_id: address_id,
      type : type
    };

    // send request
    this.sendRequest(data, function (response) {
      if (response) {
        //format response data
        let data = thisObj.formatResponseData(response);

        //fire success event
        thisObj.onSuccessEvent(data, {
          action: action,
          request_id: requestId,
        });
      }
    });

  }
}

export default SetDefaultAddress;